import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Signature on-load moment: each line is masked inside an overflow-hidden
// wrapper and translates up into view. No opacity-only fades.
export const KineticHeading = ({ lines, className, delay = 0, as: Tag = "span" }) => (
  <Tag className={cn("block", className)}>
    {lines.map((line, i) => (
      <span key={line + i} className="block overflow-hidden py-[0.12em] -my-[0.12em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);
